<h2 class="text-xl font-bold mb-4">Typ korrekt</h2>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-green-600 flex items-center mb-2">
    <span class="mr-2">✅</span> Akzeptieren, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>
      Der zugewiesene Typ korrekt ist (z. B. Produkt, Dienstleistung, Broschüre,
      Formular, Fachperson, Video, Termin).
    </li>
    <li>Die gewählte Kategorie und der Inhalt des Angebots übereinstimmen.</li>
  </ul>
</div>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-red-600 flex items-center mb-2">
    <span class="mr-2">❌</span> Ablehnen bzw. Änderung erforderlich, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>Der Typ nicht korrekt zugeordnet wurde.</li>
    <li>Der Inhalt eine andere Art von Angebot beschreibt als angegeben.</li>
  </ul>
</div>

<div class="mt-4 p-4 bg-blue-50 rounded-lg">
  <p class="flex items-center text-blue-800">
    <span class="mr-2">➡</span>
    <span class="font-semibold">Best Practice:</span>
    Falls der Typ falsch ist, sollte eine geeignete Auswahl aus einer
    Dropdown-Liste getroffen werden.
  </p>
</div>
